class ProplusTemplate {
  data = {};
  template:string;
  renderedTemplate:string;
  renderedDom = null;

  constructor(template, data = {}) {
    if (!template)
      template = '';
    if (typeof template === 'object') {
      if (template instanceof jQuery)
        template = (<any>template).html();
    }

    if (template.match(/^[a-z0-1\-_]+$/i))
      this.loadTemplate(template);
    else
      this.setTemplate(template);

    this.data = data;
    
  }
  loadTemplate(id) {
    let $templateElm = jQuery('script#' + id);
    this.setTemplate($templateElm.html())
  }
  setTemplate(template) {
    this.template = '' + template;
  }

  renderTemplate(data = {}) {
    data = Object.assign({}, this.data, data);

    let template = this.template;
    for (let key in data) {
      let value = data[key];
      template = template.split("{" + key + "}").join(value ? value : "");
    }
    

    return template;
  }

  render(data = {}) {
    data = Object.assign({}, this.data, data);

    let renderedTemplate = this.renderTemplate(data);
    let renderedDom = jQuery(renderedTemplate);
    return renderedDom;
  }

  toString() {
    return this.template;
  }
}